import React, { Component } from 'react';

const BASE = '/idea-bet.live/theme/1ufaai/';
const IMG = BASE + 'build/images/';

const cards = [
    {
        icon: IMG + 'ic_menu_promotion_ball_step_free.png',
        title: 'สเต็ปฟรี 100',
        subtitle: 'Cashback 100 บาท เพียงแค่ เข้าแทง บอลสเต็ป',
        steps: [
            'เข้าเดิมพัน (เฉพาะ บอลสเต็ปเท่านั้น)',
            'เลือก เมนู สเตปฟรี 100',
            'กดขอรับเครดิตรอ 1 นาที',
            'เสร็จขั้นตอน เงินเข้าระบบตามเงื่อนไขสเต็ปฟรี 100',
        ],
    },
    {
        icon: IMG + 'ic_menu_username.png',
        title: 'เข้าเล่นไม่ต้องจำยูส',
        subtitle: 'ไม่ต้องจำยูสเซอร์เข้าระบบ หรือก๊อปยูสมาเล่นอีกต่อไป เพียงแค่สมัครโดยใช้เบอร์โทร',
        steps: [
            'ไปที่ สมัครสมาชิก',
            'กรอกเบอร์โทรศัพท์ของคุณ',
            'ยืนยัน OTP',
            'ตั้งรหัสผ่านที่มีแต่คุณรู้',
            'กรอกข้อมูลบัญชีธนาคาร',
            'ฝากเงินเพื่อรับยูสเข้าระบบ',
            'เข้าเล่นได้เลยไม่ต้องยูสยูฟ่า',
        ],
    },
    {
        icon: IMG + 'ic_menu_bet_limit.png',
        title: 'ปรับไม้คาสิโน',
        subtitle: 'คุณสามารถปรับไม้ได้เอง ไม่ต้องผ่านแอดมิน',
        steps: [
            'เลือกเมนู ปรับไม้',
            'ดูตารางการแทง',
            'เลือกกลุ่มที่คุณต้องการ',
            'กด ยืนยัน เสร็จขั้นตอน',
        ],
    },
    {
        icon: IMG + 'ic_menu_promotion_return_bonus.png',
        title: 'รับโบนัส 5% ทุกสัปดาห์',
        subtitle: 'ขอรับยอดเสีย หรือขอรับโบนัสได้ด้วยตัวท่านเอง',
        steps: [
            'กดขอรับโบนัส',
            'กด รับโบนัส เสร็จขั้นตอน',
        ],
    },
];

class Instructions extends Component {
    render() {
        return (
            <div className="x-instruction-main-index-container x-default-bg-center" style={{ paddingTop: '72px', minHeight: '100vh' }}>
                <link rel="stylesheet" href={BASE + 'style.css'} />

                {/* Banner */}
                <div style={{ width: '100%', maxHeight: '300px', overflow: 'hidden' }}>
                    <img src={BASE + 'build/images/banner-instruction.png?v=1'} alt="รูป cover หน้าแนะนำผู้ใช้" style={{ width: '100%', objectFit: 'cover' }} />
                </div>

                <div className="container py-4">
                    <div className="text-center mb-4">
                        <h1 style={{ color: '#EFD0A0', fontSize: '24px', fontWeight: '700' }}>ทางเข้า UFAgrand168 เว็บตรงไม่ผ่านเอเย่นต์</h1>
                        <p style={{ color: '#ccc' }}>พนันบอลออนไลน์ ทางเข้า UFAgrand168 มีโปรเยอะที่สุดในไทย คืนเงินสูงกว่าทุกเจ้า เหนือกว่าทุกระดับ</p>
                    </div>

                    {/* Shortcut tabs */}
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '32px' }}>
                        {cards.map((c, i) => (
                            <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: 'rgba(0,0,0,0.4)', border: '1px solid #b8962e', borderRadius: '10px', padding: '12px 16px', cursor: 'pointer', minWidth: '100px', textAlign: 'center' }}>
                                <img src={c.icon} alt={c.title} style={{ width: '40px', height: '40px', objectFit: 'contain', marginBottom: '6px' }} />
                                <span style={{ color: '#EFD0A0', fontSize: '12px', fontWeight: '600' }}>{c.title}</span>
                            </div>
                        ))}
                    </div>

                    {/* Cards */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '16px' }}>
                        {cards.map((c, i) => (
                            <div key={i} style={{ border: '1px solid #b8962e', borderRadius: '12px', padding: '20px', background: 'rgba(0,0,0,0.4)' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                                    <img src={c.icon} alt={c.title} style={{ width: '36px', height: '36px', objectFit: 'contain' }} />
                                    <h3 style={{ color: '#EFD0A0', fontSize: '16px', margin: 0 }}>{c.title}</h3>
                                </div>
                                <p style={{ color: '#aaa', fontSize: '13px', marginBottom: '12px' }}>{c.subtitle}</p>
                                <ol style={{ paddingLeft: '18px', margin: 0 }}>
                                    {c.steps.map((s, j) => (
                                        <li key={j} style={{ color: '#ccc', fontSize: '13px', lineHeight: '2' }}>{s}</li>
                                    ))}
                                </ol>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}
export default Instructions;
